if (!customElements.get('hc-complementary-products')) {
	customElements.define('hc-complementary-products', class HcComplementaryProducts extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('hc-cart-drawer');
      // Find submit button - it may be in the header (outside this element) or inside
      this.submitButton = this.querySelector('[type="submit"]') || this.closest('aside')?.querySelector('.hc-complementary-products__add-all-btn[type="submit"]');
      if (this.submitButton && document.querySelector('hc-cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      // Always set up change handlers if we have quantity inputs or variant selects
      const hasQuantityInputs = this.querySelectorAll('.quantity__input').length > 0;
      const hasVariants = this.querySelectorAll('.select__select,input.hc-complementary-variant-id[data-available="true"]').length > 0;
      
      if(hasQuantityInputs || hasVariants) {
        this.price = this.querySelector('.hc-complementary__total__price');
        // Listen for changes on variant selects and hidden inputs
        this.querySelectorAll('.select__select,input.hc-complementary-variant-id[data-available="true"]').forEach(element => {
          element.addEventListener('change', this.onChangeHandler.bind(this));
        });
        // Listen for both 'change' and 'input' events on quantity inputs, and also on quantity buttons
        this.querySelectorAll('.quantity__input').forEach(element => {
          element.addEventListener('change', this.onChangeHandler.bind(this));
          element.addEventListener('input', this.onChangeHandler.bind(this));
        });
        // Also listen to quantity buttons to catch button clicks
        this.querySelectorAll('.quantity__button').forEach(element => {
          element.addEventListener('click', () => {
            // Small delay to allow quantity-input to update the value
            setTimeout(() => this.onChangeHandler({ target: element.closest('quantity-input')?.querySelector('.quantity__input') || element }), 50);
          });
        });
      }
    }
    
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      const spinner = this.submitButton.querySelector('.loading-overlay__spinner') || this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      
      let formData = {};
      if (this.cart) {
        // Use HC cart utils for comprehensive section rendering
        const sectionsToRender = window.HCCartUtils?.getSectionsToRender() || this.cart.getSectionsToRender();
        formData.sections = sectionsToRender.map((section) => section.id).filter(Boolean);
        formData.sections_url = window.location.pathname;
        this.cart.setActiveElement(document.activeElement);
      }
      
      /* Collection items */
      let items = [];
      this.querySelectorAll('.hc-complementary__item').forEach((item) => {
        const quantityInput = item.querySelector('.quantity__input');
        if(parseInt(quantityInput.value) > 0) {
          items.push({
            id: item.querySelector('.hc-complementary-variant-id').value,
            quantity: quantityInput.value
          });
        }
      });
      formData.items = items;
      config.body = JSON.stringify(formData);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log('HC Complementary Products response:', response);
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
            } else if (!this.cart) {
              // If no cart drawer is available, try to find it or show error
              console.warn('HC Complementary Products: Cart drawer not found');
              this.handleErrorMessage('Cart drawer not available');
              return;
            }
            this.error = false;
            document.dispatchEvent(new CustomEvent('afterCartChanged'));
            // Fetch the latest cart data and render it
            this.cart.fetchCart().then(cartData => {
              this.cart.renderContents(cartData, true);
            });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          const spinner = this.submitButton.querySelector('.loading-overlay__spinner') || this.querySelector('.loading-overlay__spinner');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    onChangeHandler(evt) {
      if(evt.target.classList.contains('select__select')) {
        const currentItem = evt.target.closest('.hc-complementary__item');
        const itemAttributeTag = evt.target.querySelector('option:checked');
        this.updatePrice(currentItem.querySelector('.price'), parseInt(itemAttributeTag.dataset.price), parseInt(itemAttributeTag.dataset.compareAtPrice), true);
        const imageTag = currentItem.querySelector('img');
        if(itemAttributeTag.dataset.featuredImage) {
          let srcset = '';
          const imageWidth = parseInt(itemAttributeTag.dataset.featuredImageWidth);
          const originImageSrc = itemAttributeTag.dataset.featuredImage;
          const widths = [275, 550, 710, 1420];
          widths.forEach(width => {
            if(imageWidth >= width) {
              srcset += `${originImageSrc}&width=${width} ${width}w,`;
            }
          });
          srcset += `${originImageSrc} ${imageWidth}w`;
          imageTag.srcset = srcset;
          imageTag.classList.add('use-variant-image');
        } else if(imageTag.classList.contains('use-variant-image')){
          imageTag.srcset = currentItem.dataset.featuredImage;
          imageTag.classList.remove('use-variant-image');
        }
      } 
      let totalPrice = 0, totalCompareAtPrice = 0, totalQuantity = 0;
      this.querySelectorAll('.hc-complementary__item').forEach(item => {
        const variantTag = item.querySelector('.hc-complementary-variant-id');
        let attributeTag = variantTag;
        if(variantTag.classList.contains('select__select')) {
          attributeTag = variantTag.querySelector('option:checked');
        }
        if(attributeTag.dataset.available === 'true') {
          const input = item.querySelector('.quantity__input');
          const quantity = parseInt(input.value);
          totalQuantity += quantity;
          totalPrice += parseInt(attributeTag.dataset.price) * quantity;
          totalCompareAtPrice += parseInt(attributeTag.dataset.compareAtPrice) * quantity;
        }
      });
      if(this.price) {
        this.updatePrice(this.price, totalPrice, totalCompareAtPrice, true);
      }
      if(this.submitButton) {
        if(totalQuantity > 0) {
          this.submitButton.removeAttribute('disabled');
        } else {
          this.submitButton.setAttribute('disabled', 'disabled');
        }
      }
    }

    updatePrice(priceElement, price, compareAtPrice, noConvert) {
      priceElement.update(price, compareAtPrice, noConvert);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
